import { createContext } from 'react';

type AiConversationContextType = {
  isConversationStarted: boolean;
  setIsConversationStarted: (value: boolean) => void;
  showScenarioDetails: boolean;
  setShowScenarioDetails: (value: boolean) => void;
  handleExitChat: () => void;
  aiRolePlayId: number | null;
};

const AiConversationContext = createContext<AiConversationContextType>({
  isConversationStarted: false,
  setIsConversationStarted: () => {},
  showScenarioDetails: true,
  setShowScenarioDetails: () => {},
  handleExitChat: () => {},
  aiRolePlayId: null,
});

export default AiConversationContext;
